export function cardChangedSince(cardChangedAt: string | null | undefined, failedAt: string | null | undefined): boolean {
  if (!cardChangedAt) return false;
  const changed = Date.parse(cardChangedAt);
  if (Number.isNaN(changed)) return false;
  if (!failedAt) return true;
  const failed = Date.parse(failedAt);
  return Number.isNaN(failed) || changed > failed;
}
